<span cobaltModalTitle aria-label="No Internet Connection">
  No Internet Connection</span
>

<div cobaltModalContent>
  Please check your device's network settings and try again.
</div>

<div cobaltModalActions>
  <button
    (click)="tryAgainClick()"
    [tabIndex]="1"
    cobaltButtonGhost
    aria-label="Try Again"
  >
    TRY AGAIN
  </button>
</div>
